import { customEnglishFont, customPersianFont } from '../helpers/elements'
import en_us from './en'

function getLanguage(): 'fa' | 'en' {
  const pathLang = window.location.pathname.split('/')[1]
  if (pathLang === 'en' || pathLang === 'fa') {
    return pathLang
  }
  return localStorage.lang || 'fa'
}

export { getLanguage }
const fa_ir: { [key: string]: string } = require('./fa.json')

export const lang = getLanguage()

const directions = {
  fa: 'rtl',
  en: 'ltr'
}

export function getDirection() {
  return directions[lang]
}

const translate = {
  fa: fa_ir,
  en: en_us
}

export function getTranslate(
  text: string,
  variables?: { [key: string]: string | number }
) {
  let translated = translate[lang][text] || text

  if (variables) {
    Object.keys(variables).forEach((key) => {
      const reg = new RegExp(`{${key}}`, 'g')
      translated = translated.replace(reg, String(variables[key]))
    })
  }

  return translated
}

const fonts = {
  fa: customPersianFont || 'IRANSans',
  en: customEnglishFont || 'Nunito'
}

export function getFont() {
  return fonts[lang]
}

export function changeLang(newLang: string) {
  if (newLang === lang) {
    return
  }
  localStorage.setItem('lang', newLang)
  const temp = window.location.href.replace(lang, newLang)
  window.location.href = temp
}

export const languagesList = [
  {
    key: 'EN',
    value: 'English'
  },
  {
    key: 'FA',
    value: 'فارسی'
  },
  {
    key: 'AR',
    value: 'العربية'
  }
]

export function getLangLabel(input: string) {
  const response = languagesList.find((item) => item.key === input)

  return response?.value
}

export function getIransansFont() {
  const cssId = 'iransansFontScript'
  if (!document.getElementById(cssId)) {
    const head = document.getElementsByTagName('head')[0]
    const link = document.createElement('link')
    link.id = cssId
    link.rel = 'stylesheet'
    link.type = 'text/css'
    // link.href = `${WBS_BACK_BASE_URL}/searchbox/fonts/iransans.css`
    link.media = 'all'
    head.appendChild(link)
  }
}
